const SESSION_FIELD_REVIEWS_RATE = 'reviews_rate_by_user';

export const getReviewsUserRated = () => {
    try {
        if (window.sessionStorage) {
            const items = sessionStorage?.getItem(SESSION_FIELD_REVIEWS_RATE);
            return items ? JSON.parse(items) : null;
        }
    } catch (e) {
        console.error('Error accessing sessionStorage:', e);
    }
    return null;
};

export const updateReviewsUserRated = (likes, dislikes) => {
    try {
        if (window.sessionStorage) {
            sessionStorage.setItem(
                SESSION_FIELD_REVIEWS_RATE,
                JSON.stringify({
                    likes: likes,
                    dislikes: dislikes
                })
            );
        }
    } catch (e) {
        console.error('Error accessing sessionStorage:', e);
    }
};

export const setReviewRate = (reviewId, isLike) => {
    try {
        if (window.sessionStorage) {
            let reviewsUserRated = getReviewsUserRated();
            if (reviewsUserRated) {
                let { likes = [], dislikes = [] } = reviewsUserRated;
                let newLikes = likes;
                let newDislikes = dislikes;

                if (isLike) {
                    newLikes = [reviewId, ...newLikes.filter(id => id !== reviewId)];
                } else {
                    newDislikes = [reviewId, ...newDislikes.filter(id => id !== reviewId)];
                }

                updateReviewsUserRated(newLikes, newDislikes);
            } else {
                if (isLike) updateReviewsUserRated([reviewId], []);
                else updateReviewsUserRated([], [reviewId]);
            }
        }
    } catch (e) {
        console.error('Error accessing sessionStorage:', e);
    }
};
